


















import HotelItem from '../common/hotel_item.vue'
import { Component, Mixins, Inject, Provide, Watch } from 'vue-property-decorator'
import SearchCategory from '../common/search_category.vue'
import SearchLoadList from '../mixins/LoadList'
import Screen from '../common/search_screen.vue'
import { List, Toast, Sticky } from 'vant'
import { namespace } from 'vuex-class'
import { SearchRefresh } from '../searchAll/index.vue'
import { getSearchResult, RequestType } from '../../search-service'
import { hotelSort } from '@/app/core/constant/search'
const searchResModule = namespace('searchRes') //vuex

@Component({
  components: {
    [List.name]: List,
    [Sticky.name]: Sticky,
    HotelItem,
    SearchCategory,
    Screen
  }
})
export default class SearchProduct extends Mixins(SearchLoadList) {
  @searchResModule.Mutation setHotelNum!: (arg: number | null) => void
  @searchResModule.State hotelSortInfo!: any
  @searchResModule.Mutation selectHotelSortInfo!: (arg: string) => void
  @searchResModule.Mutation resetHotel!: () => void //重置筛选项

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200009')
  clickid_200009!: string

  @Provide()
  clickid_200031 = '200031'

  hotelSorts = hotelSort

  mounted() {
    const { searchKey = '', tabs = '' } = this.$route.query
    this.keyWord = searchKey as string
    this.tabs = tabs as string
    this.onLoad()
    setTimeout(() => {
      this.$bus.$on(SearchRefresh.RefreshHotel, () => {
        this.refresh()
      })
    }, 1000)
  }

  destroyed() {
    this.$bus.$off(SearchRefresh.RefreshHotel)
  }

  get emptyHeight() {
    const { top, height } = (this.$refs.classify as HTMLElement).getBoundingClientRect() || {}
    return document.body.clientHeight - top - height
  }

  clickHotelSort(item: any) {
    this.selectHotelSortInfo(item)
    this.refresh()
  }

  async onLoad() {
    let sortInfo: any = {}
    if (this.hotelSortInfo) {
      sortInfo = JSON.parse(JSON.stringify(this.hotelSortInfo))
      delete sortInfo.name
    }
    const result = await getSearchResult({ tabs: this.tabs, keyWords: this.keyWord, type: RequestType.RequestHotel, start: this.start, ...sortInfo })
    const { code, data, msg } = result
    if (+code === 1) {
      if (data.hotelInfo) {
        const { total, list: newData = [] } = data.hotelInfo
        this.setHotelNum(total)
        if (newData.length < 10) {
          this.finished = true
        }
        this.start = this.start + newData.length
        this.list.push(...newData)
      }
    } else {
      this.errormsg = msg || '加载出错，请稍后再试'
      if (this.list.length > 0) {
        this.error = true
        Toast(this.errormsg)
      }
    }
    this.loading = false
  }

  refresh() {
    this.reset()
    this.$nextTick(() => {
      if (this.isFixed) {
        window.scrollTo(0, this.scrollTop)
      }
    })
    this.onLoad()
  }

  resetCondition() {
    this.resetHotel()
    this.refresh()
  }
}
